// import utils from "@/utils";
// import insider from "./insider";
import { Ajax } from "../utils/base";
import IP from "../config/config"
export function getSnaApi (param) {
    const url = IP.shareApis() + '/Oauth/share';
    return Ajax(url, param, "GET");
}
